import type { FiatPrice, Prices } from "@b2bportal/purchase-api";
import { getModifiedLegacyPrices, getModifiedPrices } from "halifax";
import { Prices as LegacyPrices } from "redmond";

/**
 * Applies one or more discount amounts to a FiatPrice object.
 * @param discounts - An array of discount amounts to apply
 * @param price - The FiatPrice object to apply the discount to
 * @returns A new FiatPrice object with the discount(s) applied
 */
export const applyDiscountValueToFiatPrice = (
  price: FiatPrice,
  discounts: number[]
) =>
  discounts.reduce((acc, curr) => ({ ...acc, value: acc.value - curr }), price);

/**
 * Transforms price data by converting all price values to their absolute values.
 *
 * @param price - The price object containing values to be transformed
 * @returns A new price object with all values converted to their absolute values
 */
export function getAbsolutePrices(price: Prices): Prices;
export function getAbsolutePrices(price: LegacyPrices): LegacyPrices;
export function getAbsolutePrices(
  price: Prices | LegacyPrices
): Prices | LegacyPrices {
  if ("rewards" in price) {
    return getModifiedLegacyPrices(price, (value) => Math.abs(value));
  }
  return getModifiedPrices(price, (value) => Math.abs(value));
}
